<!--
  功能：数字化转型页面
  cyz
  邮箱：cyz@126.com
  时间：2023年02月24日 09:22:10
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="service-container">
        <div class="service-img">
            <div class="service-title">
                <h1>数字化转型咨询</h1>
                <h5>国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。</h5>
            </div>
            <!-- <img src="../../assets/img/lbt/data.png" style="width: 100%;height: 100%;"/> -->
        </div>
        <div class="data-box">
            <div class="data-specific">
                <div class="specifi">
                    <div class="specifi-title">
                        <img src="../../assets/img/tb.png">
                        <span>咨询服务特点</span>
                    </div>
                    <div class="specifi-content">
                        <h5>专业的数字化转型咨询团队丰富的行业咨询经营，为客户提供专业的数字化转型咨询服务。</h5>
                        <p class="rect">专业的业务团队</p>
                        <p class="rect">丰富的行业经验</p>
                        <p class="rect">产品化的解决方案</p>
                    </div>
                </div>
                <div class="specifi-icon">
                    <img src="../../assets/img/szhzx-1.png" style="width: 100%;height: 90%;"/>
                </div>
            </div>
            <div class="advantages">
                <div class="advantages-title">
                    <img src="../../assets/img/tb.png">
                    <span>服务优势</span>
                </div>
                <div class="advantages-content">
                    <div class="advantages-box">
                        <div class="advantages-icon">
                            <img src="../../assets/img/1.png"/>
                        </div>
                        <div class="advantages-name">
                            <h5>辅助管理决策</h5>
                        </div>
                        <div class="advantages-descript">
                            <p>基于大数据、AI智能分析，决策更直观更有依据</p>
                        </div>
                    </div>
                    <div class="advantages-box">
                        <div class="advantages-icon">
                            <img src="../../assets/img/2.png"/>
                        </div>
                        <div class="advantages-name">
                            <h5>基层赋能</h5>
                        </div>
                        <div class="advantages-descript">
                            <p>从线下转到线上使工作更方便更有效率</p>
                        </div>
                    </div>
                    <div class="advantages-box">
                        <div class="advantages-center">
                            <div class="advantages-icon">
                                <img src="../../assets/img/3.png"/>
                            </div>
                            <div class="advantages-name">
                                <h5>战略分析</h5>
                            </div>
                            <div class="advantages-descript">
                                <p>基于数字化智能分析平台，更利于战略分析</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  // 组件名称
  name: 'Transform',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  created () {
  },
  
  mounted () {
  },
}
</script> 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style lang="less" scoped>
    .service-container{
        width: 100%;
        height: auto;
        .service-img{
            width: 100%;
            height: 450px;
           // background-color: #001847;
           background-image: linear-gradient(to bottom right,#32496d,#001847);
            position: relative;
            float:left;
            .service-title{
                position: absolute;
                z-index: 999;
                left:10%;
                top:35%;
                h1{
                    font-size: 64px;
                    color:#fff;
                    font-weight: inherit;
                    padding: 0;
                    margin:0;
                }
                h5{
                    font-size: 24px;
                    color: #fff;
                    font-weight: inherit;
                    
                }
            }
            img{
                width:100%;
                height:400px;
                opacity: 1.0;
            }
        }
        .data-box{
            width: calc(100% - 280px);
            height:auto;
            margin:0 140px 0 140px;
            float:left;
            .data-specific{
                width:100%;
                height:auto;
                float:left;
                display:flex;
                margin:40px 0 40px 0;
                justify-content:space-between;
                .specifi{
                    width: 45%;
                    height: 400px;
                    .specifi-title{
                        width: 100%;
                        height:48px;
                        line-height:48px;
                        img{
                            width:36px;
                            height: 36px;
                            margin-right: 5px;
                        }
                        span{
                            color: #1a1c1e;
                            font-size: 30px;
                        }
                    }
                    .specifi-content{
                        color: #46484a;
                        font-size: 16px;
                        font-weight: 300;
                        h5{
                            width:80%;
                            height:28px;
                            line-height:28px;
                            font-size:18px;
                            font-weight:inherit;
                            padding-bottom:12px;
                        }
                        .rect{
                            position: relative;
                            padding-left: 15px;
                            width:80%;
                            height:14px;
                            padding-top: 20px;
                            }
                            .rect::before{
                                z-index: 999;
                                content: "";
                                position: absolute;
                                top: 25px;
                                left: 0;
                                height: 12px;
                                width: 12px;
                                background-color: #53cac6;
                            }
                    }
                }
                .specifi-icon{
                    width: 55%;
                    height: 400px;
                    img{
                        width: 100%;
                        height:100%;
                    }    
                }
            }
            .advantages{
                width: 100%;
                height: auto;
                float: left;
                margin-bottom: 15px;
                .advantages-title{
                    width: 100%;
                    height:72px;
                    line-height:72px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    img{
                            width:36px;
                            height: 36px;
                            margin-right: 5px;
                        }
                    span{
                        color: #1a1c1e;
                        font-size:30px;
                    }
                   
                }
                .advantages-content{
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: flex-start;
                    font-size: 16px;
                    color: #46484a;
                    .advantages-box:nth-child(1){
                        width: calc(100% / 3);
                        height:300px;
                        .advantages-icon{
                            width:100%;
                            height:auto;
                            padding-top: 70px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img{
                                width: 72px;
                                height: 72px;
                            }
                        }
                        .advantages-name{
                                width: 100%;
                                height: 56px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                h5{
                                    font-weight:inherit;
                                    font-size: 20px;
                                    line-height: 56px;
                                    color: #2b2d2f;
                                }
                        }
                        .advantages-descript{
                            width: 100%;
                            height: 36px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 16px;
                            color: #46484a;
                            p{
                                line-height: 36px;
                                
                            }
                        }
                    }
                    .advantages-box:nth-child(2){
                        width: calc(100% / 3);
                        height:300px;
                        .advantages-icon{
                            width:100%;
                            height:auto;
                            display: flex;
                            padding-top: 70px;
                            justify-content: center;
                            align-items: center;
                            img{
                                width: 72px;
                                height: 72px;
                            }
                        }
                       .advantages-name{
                            width: 100%;
                            height: 56px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            h5{
                                font-weight:inherit;
                                font-size: 20px;
                                line-height: 56px;
                                color: #2b2d2f;
                            }
                       }
                       .advantages-descript{
                            width: 100%;
                            height: 36px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 16px;
                            color: #46484a;
                            p{
                                line-height: 36px;
                                
                            }
                       }
                    }
                    .advantages-box:nth-child(3){
                        width: calc(100% / 3);
                        height:300px;
                        .advantages-icon{
                            width:100%;
                            height:auto;
                            display: flex;
                            padding-top: 70px;
                            justify-content: center;
                            align-items: center;
                            img{
                                width: 72px;
                                height: 72px;
                            }
                        }
                       .advantages-name{
                            width: 100%;
                            height: 56px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            h5{
                                font-weight:inherit;
                                font-size: 20px;
                                line-height: 56px;
                                color: #2b2d2f;
                            }
                       }
                       .advantages-descript{
                            width: 100%;
                            height: 36px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 16px;
                            color: #46484a;
                            p{
                                line-height: 36px;
                                
                            }
                       }
                    }
                }
            }
        }
    }
</style>
